import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, CheckCircle2, Phone } from "lucide-react";
import { products } from "../mock";
import { Button } from "./ui/button";
import { contact } from "../mock";

export default function ProductSpotlight() {
  const [idx, setIdx] = useState(0);
  const total = products.length;
  useEffect(() => {
    const t = setInterval(() => setIdx(i => (i + 1) % total), 6000);
    return () => clearInterval(t);
  }, [total]);

  const p = products[idx];

  return (
    <section className="bg-cream bg-dotted py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[11px] tracking-[0.3em] text-orange-600 font-semibold uppercase">Featured Spotlight</p>
          <h2 className="font-display text-3xl md:text-5xl font-bold mt-3 uppercase">Product of the Moment</h2>
          <span className="block w-24 h-[3px] bg-orange-500 mx-auto mt-4" />
        </div>

        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div className="relative bg-white rounded-2xl shadow-lg p-6 border border-neutral-200">
            <img src={p.image} alt={p.name} className="w-full h-[360px] md:h-[420px] object-contain" />
            <div className="absolute top-4 left-4 bg-orange-500 text-white text-xs font-bold tracking-wider uppercase px-3 py-1 rounded-full">Spotlight</div>
          </div>
          <div>
            <h3 className="font-display text-3xl md:text-4xl font-bold uppercase">{p.name}</h3>
            <span className="block w-20 h-[3px] bg-orange-500 mt-4" />
            <p className="mt-5 text-neutral-700 leading-relaxed">{p.description}</p>
            <ul className="mt-5 grid sm:grid-cols-2 gap-y-2">
              {p.features.slice(0, 4).map(f => (
                <li key={f} className="flex items-start gap-2 text-sm text-neutral-800">
                  <CheckCircle2 size={18} className="text-orange-500 shrink-0 mt-0.5" />
                  {f}
                </li>
              ))}
            </ul>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link to={`/products/${p.slug}`}>
                <Button className="bg-orange-500 hover:bg-orange-600 text-white rounded-full px-6 py-6 uppercase tracking-wider font-semibold">View Product</Button>
              </Link>
              <a href={`tel:${contact.phone}`}>
                <Button variant="outline" className="rounded-full border-neutral-300 hover:bg-neutral-900 hover:text-white px-6 py-6 uppercase tracking-wider font-semibold">
                  <Phone size={16} className="mr-2" /> Enquire
                </Button>
              </a>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-3 mt-10">
          <button onClick={() => setIdx((idx - 1 + total) % total)} className="w-10 h-10 rounded-full bg-white border border-neutral-300 hover:bg-orange-500 hover:text-white hover:border-orange-500 flex items-center justify-center transition-colors">
            <ChevronLeft size={18} />
          </button>
          {products.map((_, i) => (
            <button key={i} onClick={() => setIdx(i)} className={`h-[3px] transition-all ${i === idx ? "w-10 bg-orange-500" : "w-6 bg-neutral-300"}`} />
          ))}
          <button onClick={() => setIdx((idx + 1) % total)} className="w-10 h-10 rounded-full bg-white border border-neutral-300 hover:bg-orange-500 hover:text-white hover:border-orange-500 flex items-center justify-center transition-colors">
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
}
